import React, {Component} from 'react'
import Translate from "react-translate-component";
import {Field, reduxForm} from "redux-form";
import {inputFields} from "../_redux_forms/inputFields";
import {requiredAndPassword} from "../../utils/validate";
import ServerError from "../common/ServerError";
import qs from "qs";
import withNoAuth from "../auth/withNoAuth";
import {connect} from "react-redux";
import {setPassword} from "../../redux/actions/passwordActions";
import {showFlashMessage} from "../../redux/actions/flashMessageActions";

class SetPassword extends Component{
    handleSubmit = formProps => {
        formProps.token = qs.parse(this.props.location.search, {ignoreQueryPrefix: true}).token;
        this.props.setPassword(formProps).then(response => {
            this.props.history.push('/');
            this.props.showFlashMessage("Password set successfully. Please login to continue.");
        })
    };
    render() {
        const {handleSubmit} = this.props;
        return (
            <section className="login-page">
                <div className="container">
                    <div className="auth-block">
                        <h5 className="auth-title"><Translate content='common.set_password'/></h5>
                        <form onSubmit={handleSubmit(this.handleSubmit)}>
                            <div className="form-group">
                                <label><Translate content='login.password'/></label>
                                <Field component={inputFields}
                                       className="form-control"
                                       type="password"
                                       name='password'
                                       validate={requiredAndPassword}
                                />
                            </div>
                            <div className="form-group">
                                <label><Translate content='login.confirm_password'/></label>
                                <Field component={inputFields}
                                       className="form-control"
                                       type="password"
                                       name="password_confirmation"
                                       validate={requiredAndPassword}
                                />
                            </div>
                            <div className="form-group">
                                <ServerError/>
                            </div>
                            <div className="form-group">
                                <button className="btn btn-primary btn-block" type="submit"><Translate content='common.set_password'/></button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        );
    }
}

SetPassword = reduxForm({
    form:'set-password'
})(SetPassword)
SetPassword = connect(null, {setPassword, showFlashMessage})(SetPassword)

export default withNoAuth(SetPassword)